<template>
  <div class="form__field-box" data-vv-value-path="model" :data-vv-as="label">
    <label class="form__label" v-if="label">
      {{ label }}
    </label>
    <div class="v-autocomplete v-autocomplete-public">
      <div class="v-autocomplete__input">
        <div
          class="v-input"
          :class="{
            'v-input--is-disabled': disabled,
            'v-input__error--border': !!errors.has(newName) && !model,
          }"
        >
          <input type="hidden" :name="name" :value="model" />
          <input
            class="v-input__field"
            v-model="model"
            type="text"
            :name="`_labels[${name}]`"
            autocomplete="off"
            @keyup="suggest"
            @keydown="clearTimeout"
            @keydown.enter.prevent
            :disabled="disabled"
            @blur="blur"
          />
          <div
            v-if="(!!errors.has(newName) && !model) || !!errors.has(newName)"
            class="v-input__error"
          >
            {{ errors.first(newName) }}
          </div>
        </div>
        <ul class="v-autocomplete__list" v-show="showList">
          <li
            v-for="(item, index) in suggestions"
            class="v-autocomplete__item"
            :class="{ 'v-autocomplete__item--is-selected': item === selected }"
            :key="index"
            @click="pick(item)"
          >
            {{ item }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import field from "../mixins/field";

export default {
  props: {
    options: {
      default: [],
      type: Array,
    },
    value: {
      default() {
        return [];
      },
    },
    initial: {
      default: "",
      type: String,
    },
    label: {
      default: "",
      type: String,
    },
  },
  data() {
    return {
      showList: false,
      selected: null,
      suggestions: [],
      model: this.initial,
      typingTimer: null,
      showOptionsInterval: 400,
    };
  },
  methods: {
    suggest(event) {
      let keyCode = event.keyCode;

      switch (keyCode) {
        case 38:
          if (_.indexOf(this.suggestions, this.selected) === 0) {
            this.selected = this.suggestions[this.suggestions.length - 1];
          } else {
            this.selected = this.suggestions[
              _.indexOf(this.suggestions, this.selected) - 1
            ];
          }
          break;
        case 40:
          if (
            _.indexOf(this.suggestions, this.selected) ===
            this.suggestions.length - 1
          ) {
            this.selected = this.suggestions[0];
          } else {
            this.selected = this.suggestions[
              _.indexOf(this.suggestions, this.selected) + 1
            ];
          }
          break;
        case 13:
          this.pick(this.selected);
          break;
        case 9:
          break;
        default:
          this.typing();
          break;
      }
    },
    showOptions() {
      let val = this.model,
        i = 0,
        arr = [...new Set(this.options)];

      this.suggestions = [];

      for (i = 0; i < arr.length; i++) {
        if (arr[i].indexOf(val) !== -1) {
          this.suggestions.push(arr[i]);
        }
      }
    },
    pick(item) {
      this.model = item;
      this.showList = false;
      this.selected = null;
    },
    typing() {
      clearTimeout(this.typingTimer);
      this.typingTimer = setTimeout(this.showOptions, this.showOptionsInterval);

      this.showList = true;
    },
    clearTimeout() {
      clearTimeout(this.typingTimer);
    },
    blur() {
      setTimeout(() => {
        this.showList = false;
      }, 300);
    },
  },
  mixins: [field],
};
</script>
